import angular from 'angular'
import importexcel from './importexcel'
import importexcelApi from './importexcelApi'
import importevent from './importevent'
import modalImportCtrl from './modalImportCtrl'
import modalConfirmCtrl from './modalConfirmCtrl'

export default angular
    .module('app.importexcel', [])
    .directive('importexcel', ['$rootScope', 'importevent', 'importexcelApi', 'Upload', 'logger', '$timeout', 'httpRequest', '$uibModal', importexcel])
    .service('importexcelApi', importexcelApi)
    .factory('importevent', importevent)
    .controller('modalImportCtrl', ['$scope', '$uibModalInstance', 'items1', 'httpRequest', modalImportCtrl])
    .controller('modalConfirmCtrl', modalConfirmCtrl)
    .name



// WEBPACK FOOTER //
// ./src/components/importexcel/index.js